module.exports = __webpack_public_path__ + "img/racecourse-greyville-turf.78fdc9f5.svg";